<div class="layout-ParentDiv innerDiv UserRedemptionPage"
  [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-details-section '">
  <div class="layout-dashboard">
    <p-toast key="toastmsg"></p-toast>

    <div class="show-table-active" [ngClass]="hide ? 'show-table-active   ' : 'show-table-active  '">
      <p-toast key="toastmsg"></p-toast>

      <div class="mainDivHeader">
        <div class="leftdiv">
          <h4>User Journey<span class="badge">{{ totalRecords }}</span></h4>
        </div>

        <div class="rightDiv">
          <button class="exportBTn" (click)="exportExcel()"> <span><img
                src="../../../assets/images/backend-image/header/exportIcon.svg" alt=""></span>
            Export</button>
        </div>
      </div>

      <div class="mainDivBody">
        <div class="date-filterDiv">
          <ul class="filtersList">
            <li>
              <p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby"
                optionLabel="label"></p-dropdown>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="startDate"
                class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="FROM: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <p-calendar monthNavigator="true" yearNavigator="true" yearRange="2022:2050" [(ngModel)]="endDate"
                class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true"
                placeholder="To: dd / mm / yy"></p-calendar>
            </li>
            <li>
              <button (click)="loadUserJourney(lastTableLazyLoadEvent)" class="searchFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
              </button>
            </li>
            <li>
              <button (click)="clear()" class="clearFilterBtn">
                <img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
                <span>Clear All</span>
              </button>
            </li>
          </ul>
          <div class="divider ">
            <hr>
          </div>
          <div class="filterTitle">
            <h5>Filters</h5>
            <span class="text-danger fw-bold mb-3">Note:</span>
            <ul class="mb-3">
              <li>Please select a Country first to view available States.</li>
              <li>Please select a State first to view available Cities.</li>
            </ul>
          </div>
          <div class="maincard">
            <div class="filterList">
              <ul>
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="countrylist" [filter]="true"
                    (onChange)="getStates($event)" placeholder="Select Country" optionLabel="name" appendTo="body"
                    [showClear]="true" [(ngModel)]="country"></p-dropdown>
                </li>
               
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="stateList" [filter]="true"
                    (onChange)="getCities($event)" placeholder="Select State" optionLabel="name" appendTo="body"
                    [showClear]="true" [(ngModel)]="state"></p-dropdown>
                </li>
                 <li>
                  <p-dropdown inputId="totalCoaches" [options]="cityList" [filter]="true"
                    (onChange)="loadUserJourney(lastTableLazyLoadEvent)" placeholder="Select City" optionLabel="name"
                    optionValue="name" appendTo="body" [showClear]="true" [(ngModel)]="cityName"></p-dropdown>
                </li>
                 <li>
                  <p-dropdown inputId="totalCoaches" [options]="sportList" [filter]="true"
                    (onChange)="loadUserJourney(lastTableLazyLoadEvent)" placeholder="Select Sport" optionLabel="name"
                    optionValue="id" appendTo="body" [showClear]="true" [(ngModel)]="sportName"></p-dropdown>
                </li>
                <li>
                  <p-dropdown inputId="totalCoaches" [options]="academiesList" [filter]="true"
                    (onChange)="loadUserJourney(lastTableLazyLoadEvent)" placeholder="Select Academy" optionLabel="name"
                    optionValue="id" appendTo="body" [showClear]="true" [(ngModel)]="academyId"></p-dropdown>
                </li>
               
              </ul>
            </div>
          </div>
        </div>
        <div class="maintableDiv">
          <div class="tableParanet">
            <p-table class="expandable" #dt [value]="userJourneyReportsData" [autoLayout]="true" [paginator]="true"
              [rows]="10" [lazy]="true" [scrollable]="true" scrollHeight="auto" scrollDirection="both"
              (onLazyLoad)="loadUserJourney($event)" [totalRecords]="totalRecords" [loading]="loading"
              [rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th pfrozencolumn="" class="mobileNumberTD p-element text-nowrap" style="left: 0px"
                    pSortableColumn="mobileNumber">
                    <div class="p-d-flex p-jc-between p-ai-center"> Mobile Number <p-sortIcon
                        field="mobileNumber"></p-sortIcon>
                    </div>
                  </th>
                  <th pSortableColumn="username" class="userNameTD">
                    <div class="p-d-flex p-jc-between p-ai-center"> Username <p-sortIcon
                        field="username"></p-sortIcon>
                    </div>
                  </th>
                  <th class="genderTD" pSortableColumn="gender">
                    <div class="p-d-flex p-jc-between p-ai-center"> Gender <p-sortIcon
                        field="gender"></p-sortIcon>
                    </div>
                  </th>
                  <th class="cityTD" pSortableColumn="city">
                    <div class="p-d-flex p-jc-between p-ai-center"> City <p-sortIcon
                        field="city"></p-sortIcon>
                    </div>
                  </th>
                  <th class="stateTD" pSortableColumn="state"
                    [ngClass]="hide ? 'hide-bank-small  ' : 'show-bank-small '">
                    <div class="p-d-flex p-jc-between p-ai-center"> State <p-sortIcon field="state"></p-sortIcon>
                    </div>
                  </th>
                  <th class="registrationDateTD" pSortableColumn="appInstalled">
                    <div class="p-d-flex p-jc-between p-ai-center"> App Installed <p-sortIcon
                        field="appInstalled"></p-sortIcon>
                    </div>
                  </th>
                  <th class="registrationDateTD" pSortableColumn="signedUp">
                    <div class="p-d-flex p-jc-between p-ai-center"> Signed Up <p-sortIcon
                        field="signedUp"></p-sortIcon>
                    </div>
                  </th>
                  <th class="registrationDateTD" pSortableColumn="profileCompleted"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> Profile Completed <p-sortIcon
                        field="profileCompleted"></p-sortIcon>
                    </div>
                  </th>
                  <th class="registrationDateTD" pSortableColumn="firstAction"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <div class="p-d-flex p-jc-between p-ai-center"> First Action <p-sortIcon
                        field="firstAction"></p-sortIcon>
                    </div>
                  </th>
                  <th class="text-nowrap p-element p-frozen-column action-button-td" style="justify-content: center;">
                    <div>Action</div>
                  </th>
                </tr>

                <tr>
                  <th pfrozencolumn="" class="mobileNumberTD p-element text-nowrap">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'mobileNumber', 'contains')"
                      [value]="dt.filters['mobileNumber'] ? dt.filters['mobileNumber'].value : ''" />
                  </th>
                  <th class="userNameTD">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'username', 'contains')"
                      [value]="dt.filters['username'] ? dt.filters['username'].value : ''" />
                  </th>
                  <th class="genderTD" style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'gender', 'contains')"
                      [value]="dt.filters['gender'] ? dt.filters['gender'].value : ''" />
                  </th>
                  <th class="cityTD" style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'city', 'contains')"
                      [value]="dt.filters['city'] ? dt.filters['city'].value : ''" />
                  </th>
                  <th class="stateTD show-col" style="left: 0px">
                    <input pInputText type="text"
                      (keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'state', 'contains')"
                      [value]="dt.filters['state'] ? dt.filters['state'].value : ''" />
                  </th>
                  <th class="registrationDateTD">
                    <p-dropdown [options]="booleanFilterOptions" optionLabel="label" optionValue="value"
                      [showClear]="true" appendTo="body" placeholder="Select"
                      [ngModel]="dt.filters['appInstalled'] ? dt.filters['appInstalled'].value : null"
                      (onChange)="setDownloadFlag(); dt.filter($event.value, 'appInstalled', 'equals')">
                    </p-dropdown>
                  </th>
                  <th class="registrationDateTD">
                    <p-dropdown [options]="booleanFilterOptions" optionLabel="label" optionValue="value"
                      [showClear]="true" appendTo="body" placeholder="Select"
                      [ngModel]="dt.filters['signedUp'] ? dt.filters['signedUp'].value : null"
                      (onChange)="setDownloadFlag(); dt.filter($event.value, 'signedUp', 'equals')">
                    </p-dropdown>
                  </th>
                  <th class="registrationDateTD"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <p-dropdown [options]="booleanFilterOptions" optionLabel="label" optionValue="value"
                      [showClear]="true" appendTo="body" placeholder="Select"
                      [ngModel]="dt.filters['profileCompleted'] ? dt.filters['profileCompleted'].value : null"
                      (onChange)="setDownloadFlag(); dt.filter($event.value, 'profileCompleted', 'equals')">
                    </p-dropdown>
                  </th>
                  <th class="registrationDateTD"
                    [ngClass]="hide ? 'hide-column' : 'show-column'">
                    <p-dropdown [options]="firstActionFilterOptions" optionLabel="label" optionValue="value"
                      [showClear]="true" appendTo="body" placeholder="Select"
                      [ngModel]="dt.filters['firstAction'] ? dt.filters['firstAction'].value : null"
                      (onChange)="setDownloadFlag(); dt.filter($event.value, 'firstAction', 'equals')">
                    </p-dropdown>
                  </th>
                  <th class="text-nowrap p-element p-frozen-column action-button-td" style="justify-content: center;">
                    <div class="buttonColumn">
                      <button class="addBTn" (click)="addColumns()" [ngClass]="hide ? 'show-column ' : 'hide-column'">
                        + Show Column
                      </button>
                      <button class="removeBTn" (click)="removeColumns()"
                        [ngClass]="hide ? 'hide-column' : 'show-column '">
                        - Hide Column
                      </button>

                    </div>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-userJourneyReportsData>
                <tr class="p-selectable-row">
                  <td pfrozencolumn="" class="mobileNumberTD">
                    <div class="textOverFlow1" pTooltip="{{userJourneyReportsData?.mobileNumber}}"
                      tooltipPosition="bottom">
                      {{ userJourneyReportsData?.mobileNumber }}
                    </div>
                  </td>

                  <td class="userNameTD">
                    {{ userJourneyReportsData?.username }}
                  </td>
                  <td class="genderTD">
                    {{ userJourneyReportsData?.gender }}
                  </td>
                  <td class="cityTD">
                    {{ userJourneyReportsData?.city }}
                  </td>
                  <td class="stateTD">
                    {{ userJourneyReportsData?.state }}
                  </td>
                  <td class="registrationDateTD">
                    {{ userJourneyReportsData?.appInstalled }}
                  </td>
                  <td class="registrationDateTD">
                    {{ userJourneyReportsData?.signedUp }}
                  </td>
                  <td class="registrationDateTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ userJourneyReportsData?.profileCompleted }}
                  </td>
                  <td class="registrationDateTD" [ngClass]="hide ? 'hide-column' : 'show-column'">
                    {{ userJourneyReportsData?.firstAction }}
                  </td>
                  <td class="text-nowrap p-element p-frozen-column action-button-td">
                  </td>
                </tr>
              </ng-template>

              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="7">User journey list not found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
    <p-confirmDialog [style]="{ width: '400px' }" id="confirmDialog"></p-confirmDialog>
  </div>
</div>
